import React from "react";
import { Loader2 } from "lucide-react";

export const StyleTag = ({ children, active, onClick }) => {
  const cls = `inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border transition-colors ${
    active ? "bg-violet-600 border-violet-500 text-white" : "bg-zinc-800/60 border-zinc-700 text-zinc-300 hover:border-violet-500"
  }`;
  if (onClick) {
    return (
      <button type="button" onClick={onClick} aria-pressed={!!active}
        className={`${cls} cursor-pointer`}>{children}</button>
    );
  }
  return <span className={cls}>{children}</span>;
};

export const MetaChip = ({ label, value }) => (
  <div className="flex flex-col">
    <span className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">{label}</span>
    <span className="text-sm font-mono font-semibold text-zinc-200">{value === 0 ? "0" : (value || "—")}</span>
  </div>
);

export const SectionTitle = ({ children, sub }) => (
  <div className="mb-5">
    <h2 className="text-2xl sm:text-3xl font-display font-bold tracking-tight">{children}</h2>
    {sub && <p className="text-sm text-zinc-400 mt-1">{sub}</p>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, desc, action }) => (
  <div className="flex flex-col items-center justify-center text-center py-16 px-4">
    {Icon && (
      <div className="w-16 h-16 rounded-2xl bg-zinc-800/70 flex items-center justify-center mb-4">
        <Icon size={28} className="text-violet-400" />
      </div>
    )}
    <h3 className="font-display font-semibold text-lg">{title}</h3>
    {desc && <p className="text-sm text-zinc-400 mt-1 max-w-sm">{desc}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export const Loader = () => (
  <div className="flex items-center justify-center py-24">
    <Loader2 className="animate-spin text-violet-500" size={32} />
  </div>
);

export const Card = ({ children, className = "", ...props }) => (
  <div className={`bg-[#0B0716] border border-zinc-800/80 rounded-2xl neon-card ${className}`} {...props}>
    {children}
  </div>
);
